export default function PageHeader({
  title,
  description,
  breadcrumbs,
  actions,
  meta,
  className = '',
}) {
  return (
    <div className={`mb-6 ${className}`}>
      {breadcrumbs && breadcrumbs.length > 0 && (
        <nav className="flex items-center gap-1.5 text-[12px] text-[var(--color-warm-500)] mb-2">
          {breadcrumbs.map((bc, i) => (
            <span key={i} className="flex items-center gap-1.5">
              {i > 0 && <span className="text-[var(--color-warm-300)]">/</span>}
              {bc.href ? (
                <a href={bc.href} className="hover:text-[var(--color-warm-800)] transition-colors">
                  {bc.label}
                </a>
              ) : (
                <span className="text-[var(--color-warm-700)]">{bc.label}</span>
              )}
            </span>
          ))}
        </nav>
      )}

      <div className="flex items-start justify-between gap-6 flex-wrap">
        <div className="min-w-0 flex-1">
          <h1 className="text-[26px] font-extrabold text-[var(--color-warm-900)] tracking-tight leading-tight">
            {title}
          </h1>
          {description && (
            <p className="text-[14px] text-[var(--color-warm-600)] mt-1.5 max-w-2xl">
              {description}
            </p>
          )}
          {meta && <div className="mt-3">{meta}</div>}
        </div>

        {actions && <div className="shrink-0 flex items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}
